export let EditarDescargasComponent = {
    selector: 'editarDescargas',
    template: require('./editar-descargas.html'),
    bindings: {
        descargas: '='
    },
    controller: class {

        /*@ngInject*/
        constructor(DescargasService, ToasterService) {
            Object.assign(this, {DescargasService, ToasterService});
        }

        eliminarDescarga(item) {
            this.DescargasService.eliminarDescarga(item._id)
                .then(() => {
                    this.ToasterService.popUp('success','Descarga', 'Se ha eliminado con éxito.');
                    let index = this.descargas.indexOf(item);
                    if (index != -1) {

                        // this.descargas.push(this.descargas[0])
                        this.descargas.splice(index, 1);
                    } else {
                        this.ToasterService.popUp('error','Informacion', 'Descarga no encontrada.');
                    }
                });
            // .error( err => alert(err.message));
        }
    }
};


// WEBPACK FOOTER //
// ./client/app/descargas-route/editar/editar-descargas.component.js